"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var orderListApi = _interopRequireWildcard(require("@/api/orderListApi.js"));
var orderTagApi = _interopRequireWildcard(require("@/api/orderTagApi.js"));
var systemSettingApi = _interopRequireWildcard(require("@/api/systemSetting.js"));
var _fudouActiveApi = _interopRequireWildcard(require("@/api/fudouActiveApi.js"));
var fudouActiveApi = _fudouActiveApi;
var _rsManagement = require("@/api/rsManagement.js");
var _merchantCategoryApi = require("@/api/merchantCategoryApi.js");
var _rensouApi = require("@/api/rensou/rensouApi.js");
var _rsApi = require("@/api/rsApi.js");
var _customerOrderApi = require("@/api/customerOrderApi.js");
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var _dateUtil = require("@/utils/dateUtil");
var suplierCouponsApi = _interopRequireWildcard(require("@/api/suplierCouponsApi.js"));
var _store = require("@/api/store");
var _static = require("../static");
var _transformState = _interopRequireDefault(require("@/utils/transformState.js"));
var _importTransport = _interopRequireDefault(require("./importTransport.vue"));
var _importFudouStatus = _interopRequireDefault(require("./importFudouStatus.vue"));
var _orderDetail = _interopRequireDefault(require("./orderDetail.vue"));
var _bindTag = _interopRequireDefault(require("./bindTag.vue"));
var _orderSend = _interopRequireDefault(require("./orderSend.vue"));
var _cancelOrder = _interopRequireDefault(require("./cancelOrder.vue"));
var _changeReceive = _interopRequireDefault(require("./changeReceive.vue"));
var _changePrice = _interopRequireDefault(require("./changePrice.vue"));
var _sendMsg = _interopRequireDefault(require("./sendMsg.vue"));
var _orderStatusPopup = _interopRequireDefault(require("./orderStatusPopup.vue"));
var _sendKami = _interopRequireDefault(require("./sendKami.vue"));
var _index = _interopRequireDefault(require("../downloadTask/index.vue"));
var _downloadZip = require("@/utils/downloadZip");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _utils = require("@/utils");
var _excluded = ["status"],
  _excluded2 = ["status"],
  _excluded3 = ["status"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    ImportTransport: _importTransport.default,
    ImportFudouStatus: _importFudouStatus.default,
    OrderDetail: _orderDetail.default,
    BindTag: _bindTag.default,
    OrderSend: _orderSend.default,
    CancelOrder: _cancelOrder.default,
    ChangeReceive: _changeReceive.default,
    ChangePrice: _changePrice.default,
    SendMsg: _sendMsg.default,
    OrderStatusPopup: _orderStatusPopup.default,
    SendKami: _sendKami.default,
    DownloadTask: _index.default
  },
  data: function data() {
    return {
      dashboardSummary: {
        totalDeal: 0,
        fudouDealTotal: 0,
        thirdPartyDealTotal: 0,
        // fudouRefundTotal: 0,      // 已注释：福豆退款总计
        // thirdPartyRefundTotal: 0,  // 已注释：三方支付退款总计
        couponPriceTotal: 0,
        // 新增：优惠金额总计
        supplyPriceTotal: 0,
        // 新增：供货价总计
        totalInstantDiscount: 0,
        // 新增：立减金额总计
        immediatePriceTotal: 0,
        // 新增：加油立减金额总计
        activityLuckyPromoPric: 0 // 活动福利立减金额
      },
      displaySummary: {
        totalDeal: 0,
        fudouDealTotal: 0,
        thirdPartyDealTotal: 0,
        // fudouRefundTotal: 0,      // 已注释：福豆退款总计
        // thirdPartyRefundTotal: 0,  // 已注释：三方支付退款总计
        couponPriceTotal: 0,
        // 新增：优惠金额总计
        supplyPriceTotal: 0,
        // 新增：供货价总计
        totalInstantDiscount: 0,
        // 新增：立减金额总计
        immediatePriceTotal: 0,
        // 新增：加油立减金额总计
        activityLuckyPromoPric: 0 // 活动福利立减金额
      },
      dashboardLoading: {
        // 看板各字段加载状态
        totalDeal: true,
        fudouDealTotal: true,
        thirdPartyDealTotal: true,
        couponPriceTotal: true,
        supplyPriceTotal: true,
        totalInstantDiscount: true,
        // 新增：立减金额总计
        immediatePriceTotal: true,
        // 新增：加油立减金额总计
        activityLuckyPromoPric: true
      },
      marketingExpanded: false,
      // 新增：营销汇总明细是否展开
      fudouDetailVisible: false,
      thirdPartyDetailVisible: false,
      fudouDetailList: [],
      thirdPartyDetailList: [],
      duplicateExportDialogVisible: false,
      duplicateExportData: {},
      downloadTaskDialogVisible: false,
      isExporting: false,
      // 是否正在导出
      isInQueue: false,
      // 是否在排队中
      exportMergeCellDialogVisible: false,
      // 导出方式选择弹窗
      exportMergeCell: true,
      // true=合并单元格，false=不合并单元格
      supportNoMerge: false,
      // 系统配置：是否支持不合并导出
      currentQueuePosition: 0,
      // 当前排队位置
      queueDetail: null,
      // 排队详情信息
      exportSuccess: false,
      // 导出是否成功
      exportProgress: 0,
      // 导出进度
      exportDialogTitle: '导出数据',
      // 导出弹窗标题
      exportConditionText: '',
      // 导出条件描述文本
      customColors: [{
        color: '#f56c6c',
        percentage: 20
      }, {
        color: '#e6a23c',
        percentage: 40
      }, {
        color: '#5cb87a',
        percentage: 60
      }, {
        color: '#1989fa',
        percentage: 80
      }, {
        color: '#67c23a',
        percentage: 100
      }],
      orderStateOption: _static.orderStateOption,
      goodsTypeOption: _static.goodsTypeOption,
      orderTypeOption: _static.orderTypeOption,
      pintuanOrderStates: _static.pintuanOrderStates,
      integralOrderTypeOptions: _static.integralOrderTypeOptions,
      selectTagList: [],
      // 选择标签
      customrOrderOption: [],
      // 品牌
      supplierOption: [],
      // 销售商
      merCateList: [],
      // 分类
      props: {
        children: 'child',
        label: 'name',
        value: 'id',
        emitPath: false,
        checkStrictly: true
      },
      // 分类
      constants: this.$constants,
      userOption: [{
        value: 1,
        name: '当前登陆人'
      }],
      listPram: {
        customOrderId: [],
        cardId: '',
        storeId: '',
        status: [],
        page: 1,
        limit: this.$constants.page.limit[0],
        startTime: '',
        endTime: '',
        merchantNo: '',
        storeType: '',
        oneCardOrderFlag: '',
        card_type: ''
      },
      tableKey: 0,
      listData: {
        list: [],
        total: 0
      },
      editDialogConfig: {
        visible: false,
        editId: 0,
        isEdit: 0 // 0=add 1=edit
      },
      listLoading: true,
      categoryTreeData: [],
      categoryProps: {
        value: 'id',
        label: 'name',
        children: 'child',
        expandTrigger: 'hover',
        checkStrictly: true,
        emitPath: false
      },
      orderTypeOptions: [],
      oneCardTypeOptions: [],
      storeTypeOptions: [],
      TYPE_COLOR_MAP: {
        1: 'info',
        2: 'success',
        3: 'success',
        4: '',
        5: 'info',
        6: 'warning',
        7: 'danger',
        8: '',
        9: ''
      },
      customers: [],
      fuCardOptions: [],
      storeOptions: [],
      visibleStatusPopup: false,
      customerOrderList: [],
      isFormVisible: false,
      // 控制更多查询条件的显示状态
      brandOption: [],
      dateRange: [],
      datePickerOptions: {
        shortcuts: [{
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近半年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      userType: null,
      ljcType: null
    };
  },
  computed: {
    // 是否为代运营或小程序客户账号
    isAgentOrMiniApp: function isAgentOrMiniApp() {
      // userType === 5 表示小程序客户账号，ljcType 存在表示代运营
      return this.userType === 5 || this.ljcType;
    },
    showMerchantStoreTypeFilter: function showMerchantStoreTypeFilter() {
      return [100, 101, 102].includes(Number(this.listPram.orderType));
    },
    // 新增：营销汇总合计 = 优惠金额 + 立减金额 + 加油立减金额 + 活动福利立减金额
    marketingTotal: function marketingTotal() {
      return Number(this.displaySummary.couponPriceTotal || 0) + Number(this.displaySummary.totalInstantDiscount || 0) + Number(this.displaySummary.immediatePriceTotal || 0) + Number(this.displaySummary.activityLuckyPromoPric || 0);
    },
    // 新增：营销汇总加载状态
    marketingLoading: function marketingLoading() {
      return this.dashboardLoading.couponPriceTotal || this.dashboardLoading.totalInstantDiscount || this.dashboardLoading.immediatePriceTotal || this.dashboardLoading.activityLuckyPromoPric;
    }
  },
  created: function created() {
    if (this.$getHomeType()) {
      this.ljcType = this.$getHomeType().ljcType;
    }
    this.getCustomers();
    this.customrOrderRemoteMethod();
    this.getFuCardOptions();
    this.loadMerchantStoreTypeOptions();
    this.userType = JSON.parse(_jsCookie.default.get('JavaInfo')).type;
    console.log(this.userType, 'userType');
  },
  mounted: function mounted() {
    this.initSearch();
    this.fetchDashboard();
    if (this.$route.query.status) {
      this.listPram.status = [Number(this.$route.query.status)];
      this.handerSearch();
    } else {
      this.handlerGetListData(this.listPram);
    }
    // 初始化日期范围为空
    this.dateRange = [];
    // 处理URL参数，自动打开订单详情
    var _this$$route$query = this.$route.query,
      orderNo = _this$$route$query.orderNo,
      openDetail = _this$$route$query.openDetail;
    if (orderNo && openDetail) {
      this.openOrderDetail(orderNo);
    }
  },
  methods: _defineProperty({
    throttle: _throttle.default,
    transformState: _transformState.default,
    // 生成导出条件描述文本
    generateExportConditionText: function generateExportConditionText() {
      var _this = this;
      var exportType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '订单导出';
      var conditions = [];
      var p = this.listPram;

      // 导出类型
      conditions.push("\u3010".concat(exportType, "\u3011"));

      // 时间范围
      if (p.startTime && p.endTime) {
        conditions.push("\u8BA2\u5355\u65F6\u95F4\uFF1A".concat(p.startTime, " \u81F3 ").concat(p.endTime));
      } else if (p.startTime) {
        conditions.push("\u8BA2\u5355\u65F6\u95F4\uFF1A".concat(p.startTime, " \u8D77"));
      } else if (p.endTime) {
        conditions.push("\u8BA2\u5355\u65F6\u95F4\uFF1A\u81F3 ".concat(p.endTime));
      } else {
        conditions.push('订单时间：全部');
      }

      // 订单编号
      if (p.orderNo) {
        conditions.push("\u8BA2\u5355\u7F16\u53F7\uFF1A".concat(p.orderNo));
      }

      // 微信订单号
      if (p.outOrderNo) {
        conditions.push("\u5FAE\u4FE1\u8BA2\u5355\u53F7\uFF1A".concat(p.outOrderNo));
      }

      // 收件人
      if (p.receiverName) {
        conditions.push("\u6536\u4EF6\u4EBA\uFF1A".concat(p.receiverName));
      }

      // 收件电话
      if (p.receiverPhone) {
        conditions.push("\u6536\u4EF6\u7535\u8BDD\uFF1A".concat(p.receiverPhone));
      }

      // 订单状态
      if (Array.isArray(p.status) && p.status.length > 0) {
        var statusNames = p.status.map(function (status) {
          var statusObj = _this.orderStateOption.find(function (item) {
            return item.value === status;
          });
          return statusObj ? statusObj.label : status;
        });
        conditions.push("\u8BA2\u5355\u72B6\u6001\uFF1A".concat(statusNames.join('、')));
      } else {
        conditions.push('订单状态：全部');
      }

      // 下单人手机号
      if (p.phone) {
        conditions.push("\u4E0B\u5355\u4EBA\u624B\u673A\uFF1A".concat(p.phone));
      }

      // 商品分类
      if (p.categoryId) {
        conditions.push('商品分类：已选择');
      }

      // 品牌
      if (p.brandId) {
        var brandObj = this.brandOption.find(function (item) {
          return item.id === p.brandId;
        });
        conditions.push("\u54C1\u724C\uFF1A".concat(brandObj ? brandObj.brandName : '已选择'));
      }

      // 供应商
      if (p.supplierId) {
        var supplierObj = this.supplierOption.find(function (item) {
          return item.id === p.supplierId;
        });
        conditions.push("\u4F9B\u5E94\u5546\uFF1A".concat(supplierObj ? supplierObj.supplierName : '已选择'));
      }

      // 订单标签
      if (p.tagId) {
        var tagObj = this.selectTagList.find(function (item) {
          return item.tagId === p.tagId;
        });
        conditions.push("\u8BA2\u5355\u6807\u7B7E\uFF1A".concat(tagObj ? tagObj.tagName : '已选择'));
      }

      // SKU编码
      if (p.skuCode) {
        conditions.push("SKU\u7F16\u7801\uFF1A".concat(p.skuCode));
      }

      // SPU名称
      if (p.spuName) {
        conditions.push("SPU\u540D\u79F0\uFF1A".concat(p.spuName));
      }

      // 订单类型
      if (p.orderType !== '' && p.orderType !== undefined) {
        var orderTypeObj = this.orderTypeOptions.find(function (item) {
          return item.key === p.orderType;
        });
        conditions.push("\u8BA2\u5355\u7C7B\u578B\uFF1A".concat(orderTypeObj ? orderTypeObj.value : '已选择'));
      } else {
        conditions.push('订单类型：全部');
      }
      if (Number(p.orderType) === 18 && p.card_type !== '' && p.card_type !== undefined) {
        var cardTypeObj = this.oneCardTypeOptions.find(function (item) {
          return item.key === p.card_type;
        });
        conditions.push("\u4E00\u5361\u901A\u7C7B\u578B\uFF1A".concat(cardTypeObj ? cardTypeObj.value : '已选择'));
      }
      if (this.showMerchantStoreTypeFilter && p.storeType) {
        var storeTypeObj = this.storeTypeOptions.find(function (item) {
          return String(item.id) === String(p.storeType);
        });
        conditions.push("\u5E97\u94FA\u7C7B\u578B\uFF1A".concat(storeTypeObj ? storeTypeObj.name : '已选择'));
      }

      // 积分订单类型
      if (p.integralOrderType !== '' && p.integralOrderType !== undefined) {
        var integralOrderTypeObj = this.integralOrderTypeOptions.find(function (item) {
          return item.value === p.integralOrderType;
        });
        conditions.push("\u79EF\u5206\u8BA2\u5355\u7C7B\u578B\uFF1A".concat(integralOrderTypeObj ? integralOrderTypeObj.label : '已选择'));
      }

      // 销售渠道
      if (p.customerId) {
        var customerObj = this.customers.find(function (item) {
          return item.id === p.customerId;
        });
        conditions.push("\u9500\u552E\u6E20\u9053\uFF1A".concat(customerObj ? customerObj.name : '已选择'));
      }

      // 归属项目
      if (p.customOrderId && p.customOrderId.length > 0) {
        conditions.push("\u5F52\u5C5E\u9879\u76EE\uFF1A\u5DF2\u9009\u62E9 ".concat(p.customOrderId.length, " \u4E2A"));
      }
      return conditions.join(' | ');
    },
    // 处理导出弹窗关闭
    handleExportDialogClose: function handleExportDialogClose(done) {
      if (this.exportProgress < 100) {
        this.$confirm('关闭后可在「导出任务」中查看进度和下载文件，是否关闭？', '提示', {
          confirmButtonText: '确定关闭',
          cancelButtonText: '继续等待',
          type: 'warning'
        }).then(function () {
          done();
        }).catch(function () {});
      } else {
        done();
      }
    },
    // 格式化等待时间
    formatWaitTime: function formatWaitTime(seconds) {
      if (!seconds || seconds <= 0) return '即将开始';
      if (seconds < 60) return "".concat(seconds, "\u79D2");
      if (seconds < 3600) return "".concat(Math.floor(seconds / 60), "\u5206\u949F");
      return "".concat(Math.floor(seconds / 3600), "\u5C0F\u65F6").concat(Math.floor(seconds % 3600 / 60), "\u5206\u949F");
    },
    // 跳转到导出任务页面
    goToExportTask: function goToExportTask() {
      this.isExporting = false;
      this.downloadTaskDialogVisible = true;
    },
    // 重复导出弹窗 - 立即下载
    handleDuplicateDownload: function handleDuplicateDownload() {
      this.duplicateExportDialogVisible = false;
      var d = this.duplicateExportData;
      if (d.downloadUrl) {
        var fullUrl = d.downloadUrl;
        // 兼容 /https:// 前缀的畸形 URL（直接去掉开头的 / 即可得到正确地址）
        if (fullUrl.startsWith('/https://')) {
          fullUrl = fullUrl.substring(1);
        } else if (fullUrl.startsWith('/')) {
          fullUrl = window.location.origin + fullUrl;
        }
        window.open(fullUrl, '_blank');
      } else if (d.fileName) {
        this.downloadFile(d.fileName);
      }
    },
    // 重复导出弹窗 - 重新导出（删除旧任务后直接发起导出，复用已选择的导出方式）
    handleRedoExport: function handleRedoExport() {
      var _this2 = this;
      var d = this.duplicateExportData;
      if (!d.taskId) {
        this.$message.error('任务ID不存在，无法重新导出');
        return;
      }
      this.$confirm('确定要删除该导出任务并重新导出吗？删除后可在导出任务中查看进度。', '重新导出', {
        confirmButtonText: '确定删除并重新导出',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return orderListApi.deleteDownloadTask(d.taskId);
            case 1:
              _this2.duplicateExportDialogVisible = false;
              _this2.$message.success('已删除旧任务，正在重新导出...');
              // 直接调用 confirmExportFastOrder，复用用户之前选择的 exportMergeCell 值
              _this2.confirmExportFastOrder();
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              _this2.$message.error('删除任务失败：' + (_t.message || '未知错误'));
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }))).catch(function () {});
    },
    // 重复导出弹窗 - 前往导出任务
    handleGoToExportTask: function handleGoToExportTask() {
      this.duplicateExportDialogVisible = false;
      this.downloadTaskDialogVisible = true;
    },
    // 格式化日期为 YYYY-MM-DD
    formatDate: function formatDate(date) {
      var y = date.getFullYear();
      var m = String(date.getMonth() + 1).padStart(2, '0');
      var d = String(date.getDate()).padStart(2, '0');
      return "".concat(y, "-").concat(m, "-").concat(d);
    },
    // 格式化日期时间为 YYYY-MM-DD HH:mm:ss
    formatDateTime: function formatDateTime(dateStr) {
      if (!dateStr) return '-';
      var date = new Date(dateStr);
      if (isNaN(date.getTime())) return dateStr;
      var y = date.getFullYear();
      var m = String(date.getMonth() + 1).padStart(2, '0');
      var d = String(date.getDate()).padStart(2, '0');
      var h = String(date.getHours()).padStart(2, '0');
      var mi = String(date.getMinutes()).padStart(2, '0');
      var s = String(date.getSeconds()).padStart(2, '0');
      return "".concat(y, "-").concat(m, "-").concat(d, " ").concat(h, ":").concat(mi, ":").concat(s);
    },
    initSearch: function initSearch() {
      this.searchBrand();
      this.getCategorySelect();
      this.searchSupplier();
      this.getAllSelectTag();
      this.getAllOrderType();
      this.getOneCardTypeOptions();
    },
    getDashboardParams: function getDashboardParams() {
      var p = this.listPram || {};
      return {
        brandId: p.brandId,
        orderNo: p.orderNo,
        outOrderNo: p.outOrderNo,
        tagId: p.tagId,
        receiverName: p.receiverName,
        receiverPhone: p.receiverPhone,
        skuCode: p.skuCode,
        spuName: p.spuName,
        statusList: p.status,
        supplierId: p.supplierId,
        categoryId: p.categoryId,
        orderType: p.orderType,
        card_type: p.card_type,
        integralOrderType: p.integralOrderType,
        customerId: p.customerId,
        customOrderId: p.customOrderId,
        cardId: p.cardId,
        storeId: p.storeId,
        startTime: p.startTime,
        endTime: p.endTime,
        phone: p.phone,
        merchantNo: p.merchantNo,
        storeType: p.storeType,
        oneCardOrderFlag: p.oneCardOrderFlag
      };
    },
    fetchDashboard: function fetchDashboard() {
      var _this3 = this;
      orderListApi.getDashboardSummary(this.getDashboardParams()).then(function (res) {
        if (res && typeof res.totalDeal !== 'undefined') {
          _this3.dashboardSummary = {
            totalDeal: Number(res.totalDeal) || 0,
            fudouDealTotal: Number(res.fudouDealTotal) || 0,
            thirdPartyDealTotal: Number(res.thirdPartyDealTotal) || 0,
            // fudouRefundTotal: Number(res.fudouRefundTotal) || 0,      // 已注释
            // thirdPartyRefundTotal: Number(res.thirdPartyRefundTotal) || 0,  // 已注释
            couponPriceTotal: Number(res.couponPriceTotal) || 0,
            // 新增：优惠金额总计
            supplyPriceTotal: Number(res.supplyPriceTotal) || 0,
            // 新增：供货价总计
            totalInstantDiscount: Number(res.totalInstantDiscount) || 0,
            // 新增：立减金额总计
            immediatePriceTotal: Number(res.immediatePriceTotal) || 0,
            // 新增：加油立减金额总计
            activityLuckyPromoPric: Number(res.activityLuckyPromoPric) || 0
          };
          _this3.runCountUp();
        }
        // 接口返回后关闭所有字段的加载动画
        _this3.dashboardLoading = {
          totalDeal: false,
          fudouDealTotal: false,
          thirdPartyDealTotal: false,
          couponPriceTotal: false,
          supplyPriceTotal: false,
          totalInstantDiscount: false,
          // 新增：立减金额总计
          immediatePriceTotal: false,
          // 新增：加油立减金额总计
          activityLuckyPromoPric: false
        };
      }).catch(function () {
        // 发生错误时也关闭所有字段的加载动画
        _this3.dashboardLoading = {
          totalDeal: false,
          fudouDealTotal: false,
          thirdPartyDealTotal: false,
          couponPriceTotal: false,
          supplyPriceTotal: false,
          totalInstantDiscount: false,
          // 新增：立减金额总计
          immediatePriceTotal: false,
          // 新增：加油立减金额总计
          activityLuckyPromoPric: false
        };
      });
    },
    runCountUp: function runCountUp() {
      var _this4 = this;
      var duration = 800;
      var steps = 24;
      var stepMs = duration / steps;
      var start = _objectSpread({}, this.displaySummary);
      var end = this.dashboardSummary;
      var step = 0;
      var _tick = function tick() {
        step++;
        var t = step >= steps ? 1 : step / steps;
        var ease = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
        _this4.displaySummary.totalDeal = start.totalDeal + (end.totalDeal - start.totalDeal) * ease;
        _this4.displaySummary.fudouDealTotal = start.fudouDealTotal + (end.fudouDealTotal - start.fudouDealTotal) * ease;
        _this4.displaySummary.thirdPartyDealTotal = start.thirdPartyDealTotal + (end.thirdPartyDealTotal - start.thirdPartyDealTotal) * ease;
        // 已注释：福豆退款总计和三方支付退款总计
        // this.displaySummary.fudouRefundTotal =
        //   start.fudouRefundTotal + (end.fudouRefundTotal - start.fudouRefundTotal) * ease;
        // this.displaySummary.thirdPartyRefundTotal =
        //   start.thirdPartyRefundTotal + (end.thirdPartyRefundTotal - start.thirdPartyRefundTotal) * ease;
        // 新增：优惠金额总计
        _this4.displaySummary.couponPriceTotal = start.couponPriceTotal + (end.couponPriceTotal - start.couponPriceTotal) * ease;
        // 新增：供货价总计
        _this4.displaySummary.supplyPriceTotal = start.supplyPriceTotal + (end.supplyPriceTotal - start.supplyPriceTotal) * ease;
        // 新增：立减金额总计
        _this4.displaySummary.totalInstantDiscount = start.totalInstantDiscount + (end.totalInstantDiscount - start.totalInstantDiscount) * ease;
        // 新增：加油立减金额总计
        _this4.displaySummary.immediatePriceTotal = start.immediatePriceTotal + (end.immediatePriceTotal - start.immediatePriceTotal) * ease;
        _this4.displaySummary.activityLuckyPromoPric = start.activityLuckyPromoPric + (end.activityLuckyPromoPric - start.activityLuckyPromoPric) * ease;
        if (step < steps) setTimeout(_tick, stepMs);
      };
      setTimeout(_tick, stepMs);
    },
    formatDashboardNum: function formatDashboardNum(val) {
      var n = Number(val);
      if (n === 0) return '0.00';
      return (Math.round(n * 100) / 100).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    formatMoney: function formatMoney(val) {
      var n = Number(val);
      if (n === 0) return '0.00';
      return '¥' + (Math.round(n * 100) / 100).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    openFudouDetail: function openFudouDetail() {
      var _this5 = this;
      orderListApi.getFudouDetail(this.getDashboardParams()).then(function (res) {
        var list = Array.isArray(res) ? res : [];
        // 不展示「退款合计」汇总行
        _this5.fudouDetailList = list.filter(function (item) {
          return item.cardTypeName !== '退款合计';
        });
        _this5.fudouDetailVisible = true;
      }).catch(function () {
        _this5.$message.error('获取福豆详情失败');
      });
    },
    openThirdPartyDetail: function openThirdPartyDetail() {
      var _this6 = this;
      orderListApi.getThirdPartyDetail(this.getDashboardParams()).then(function (res) {
        _this6.thirdPartyDetailList = Array.isArray(res) ? res : [];
        _this6.thirdPartyDetailVisible = true;
      }).catch(function () {
        _this6.$message.error('获取第三方支付详情失败');
      });
    },
    //福司令订单刷新
    loadingFSLOrder: function loadingFSLOrder(orderNo) {
      var _this7 = this;
      if (!orderNo) {
        this.$message.warning('订单编号不能为空');
        return;
      }
      orderListApi.loadingFSLOrder(orderNo).then(function (res) {
        _this7.$message.success('刷新成功');
        _this7.handerSearch(0);
      }).catch(function (err) {
        _this7.$message.error(err.message || '刷新失败');
      });
    },
    getAllOrderType: function getAllOrderType() {
      var _this8 = this;
      this.orderTypeOptions = [];
      orderListApi.getOrderTypes().then(function (res) {
        _this8.orderTypeOptions = res || [];
      });
    },
    getOneCardTypeOptions: function getOneCardTypeOptions() {
      var _this9 = this;
      (0, _store.oneCardTypeOptions)().then(function (res) {
        _this9.oneCardTypeOptions = res || [];
      });
    },
    loadMerchantStoreTypeOptions: function loadMerchantStoreTypeOptions() {
      var _this0 = this;
      (0, _rsManagement.getMerchantStoreTypeList)().then(function (res) {
        _this0.storeTypeOptions = res || [];
      }).catch(function () {
        _this0.storeTypeOptions = [];
      });
    },
    handleOrderTypeChange: function () {
      var _handleOrderTypeChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(value) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (![100, 101, 102].includes(Number(value))) {
                this.listPram.storeType = '';
              }
              if (Number(value) !== 18) {
                this.listPram.card_type = '';
              }
              // 品牌、分类、供应商ID在多商户和非多商户体系中可能重复，切换类型时必须清空旧选择。
              this.$set(this.listPram, 'categoryId', '');
              this.$set(this.listPram, 'brandId', '');
              this.$set(this.listPram, 'supplierId', '');
              this.$set(this.listPram, 'storeId', '');
              this.brandOption = [];
              this.merCateList = [];
              this.supplierOption = [];
              this.storeOptions = [];
              _context2.n = 1;
              return Promise.all([this.searchBrand(), this.getCategorySelect(), this.searchSupplier()]);
            case 1:
              this.handerSearch(0);
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function handleOrderTypeChange(_x) {
        return _handleOrderTypeChange.apply(this, arguments);
      }
      return handleOrderTypeChange;
    }(),
    // 处理日期范围变化
    handleDateRangeChange: function handleDateRangeChange(val) {
      if (val) {
        this.listPram.startTime = val[0];
        this.listPram.endTime = val[1];
      } else {
        this.listPram.startTime = '';
        this.listPram.endTime = '';
      }
      this.handerSearch(0);
    },
    // 现有的方法...
    /*    handleSelectChange(value) {
      // 将数组转换为逗号分隔的字符串
      this.listPram.customOrderId = value
       // 可以在这里调用 handerSearch 来刷新列表，如果需要的话
      this.handerSearch();
    },*/
    handerSearch: function handerSearch() {
      var doRefresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      // 是否刷新
      if (doRefresh == 1) {
        // 重置分页参数，并保留其他查询参数
        this.listPram = _objectSpread({
          page: 1,
          limit: this.$constants.page.limit[0]
        }, this.listPram);
      } else {
        // 如果不是刷新，只重置页码为 1，保留其他分页和查询参数
        this.listPram.page = 1;
      }
      // 重新加载看板数据时打开所有字段的加载动画
      this.dashboardLoading = {
        totalDeal: true,
        fudouDealTotal: true,
        thirdPartyDealTotal: true,
        couponPriceTotal: true
      };
      this.fetchDashboard();
      // 获取列表数据
      this.handlerGetListData(this.listPram);
    },
    handlerGetListData: function handlerGetListData() {
      var _this1 = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      var status = pram.status,
        requestParams = _objectWithoutProperties(pram, _excluded);
      orderListApi.ListArticle(_objectSpread(_objectSpread({}, requestParams), {}, {
        statusList: status
      })).then(function (data) {
        _this1.tableKey++;
        _this1.listData = data;
        _this1.listLoading = false;
        _this1.$nextTick(function () {
          if (_this1.$refs.orderListRef) {
            _this1.$refs.orderListRef.doLayout();
          }
        });
      }).catch(function (err) {
        _this1.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    // 导入订单
    doImport: function doImport() {
      this.$refs['ImportTransportRef'].openInit();
    },
    // 导入福豆充值状态变更
    doImportFudouStatus: function doImportFudouStatus() {
      this.$refs['ImportFudouStatusRef'].openInit();
    },
    requestUpload: function requestUpload() {},
    beforeUpload: function beforeUpload(file) {
      var formData = new FormData();
      formData.append('file', file);
      var loading = this.$loading({
        lock: true,
        text: 'Loading'
      });
      // doImportOrder(formData).then((res) => {
      //   this.$message.success('导入成功')
      //   this.getList();
      //   loading.close();
      // }).catch((err) => {
      //   this.$message.error(err.message);
      //   loading.close();
      // });
    },
    isCouponGoodsOrder: function isCouponGoodsOrder(row) {
      if (!row) return false;
      var rawType = row.type;
      if (Number(rawType) === 3) return true;
      if (row.typeName && String(row.typeName).includes('优惠券商品')) return true;
      return false;
    },
    isLuckyWheelGiftOrder: function isLuckyWheelGiftOrder(row) {
      if (!row) return false;
      var mark = '活动福利赠品';
      var hasMark = function hasMark(val) {
        return String(val || '').includes(mark);
      };
      if (hasMark(row.tagName) || hasMark(row.tagRemark)) return true;
      var items = row.orderItemList;
      if (Array.isArray(items) && items.some(function (item) {
        return hasMark(item && item.activityName);
      })) {
        return true;
      }
      return false;
    },
    // 查看订单详情
    openOrderDetail: function openOrderDetail(orderNo) {
      this.$refs['OrderDetailRef'].openDetail(orderNo);
    },
    // 异步导出
    exportList: function () {
      var _exportList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this$listPram, status, requestParams, taskResponse, taskId, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.exportDialogTitle = '订单导出';
              this.exportConditionText = this.generateExportConditionText('订单导出');
              this.isExporting = true;
              this.exportProgress = 0;
              this.isInQueue = false;
              this.currentQueuePosition = 0;
              _context3.p = 1;
              _this$listPram = this.listPram, status = _this$listPram.status, requestParams = _objectWithoutProperties(_this$listPram, _excluded2);
              _context3.n = 2;
              return orderListApi.createAsyncOrderExportTask(_objectSpread(_objectSpread({}, requestParams), {}, {
                statusList: status
              }));
            case 2:
              taskResponse = _context3.v;
              taskId = taskResponse.taskId;
              if (taskResponse.inQueue) {
                this.isInQueue = true;
                // 获取排队详情，显示最大排队位置（用户可能有多个任务在排队）
                this.fetchQueueDetailAndUpdate('ORDER_EXPORT', taskId);
              } else {
                this.isInQueue = false;
                this.pollTaskStatus(taskId);
              }
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t2 = _context3.v;
              this.isExporting = false;
              this.$message.error('创建导出任务失败: ' + _t2.message);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 3]]);
      }));
      function exportList() {
        return _exportList.apply(this, arguments);
      }
      return exportList;
    }(),
    // 获取排队详情并更新位置（显示最大排队位置）
    fetchQueueDetailAndUpdate: function () {
      var _fetchQueueDetailAndUpdate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(taskType, taskId) {
        var detail, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return orderListApi.getDownloadQueueDetail(taskType);
            case 1:
              detail = _context4.v;
              if (detail) {
                // 保存排队详情
                this.queueDetail = detail;
                // 更新最大排队位置
                if (detail.userMaxQueuePosition > 0) {
                  this.currentQueuePosition = detail.userMaxQueuePosition;
                }
              }
              // 继续轮询状态
              this.pollTaskStatusWithQueue(taskId, taskType);
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t3 = _context4.v;
              console.error('获取排队详情失败:', _t3);
              // 即使获取失败，也继续轮询
              this.pollTaskStatusWithQueue(taskId, taskType);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function fetchQueueDetailAndUpdate(_x2, _x3) {
        return _fetchQueueDetailAndUpdate.apply(this, arguments);
      }
      return fetchQueueDetailAndUpdate;
    }(),
    // 轮询任务状态
    pollTaskStatus: function () {
      var _pollTaskStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(taskId) {
        var _this10 = this;
        var pollInterval;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              pollInterval = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
                var res, taskStatus, _t4;
                return _regenerator().w(function (_context5) {
                  while (1) switch (_context5.p = _context5.n) {
                    case 0:
                      _context5.p = 0;
                      _context5.n = 1;
                      return orderListApi.getDownloadTaskStatus(taskId);
                    case 1:
                      res = _context5.v;
                      taskStatus = res && res.data ? res.data : res; // 更新进度：只有处理中状态才继续轮询，其他终态都停止
                      if (taskStatus.status === 'PROCESSING') {
                        _this10.exportProgress = Math.min(_this10.exportProgress + 5, 90);
                      } else if (taskStatus.status === 'COMPLETED') {
                        _this10.exportProgress = 100;
                        clearInterval(pollInterval);

                        // 直接使用filePath中的HTTPS地址下载文件
                        if (taskStatus.filePath) {
                          _this10.downloadFileByFilePath(taskStatus.filePath, taskStatus.fileName);
                        } else if (taskStatus.fileName) {
                          _this10.downloadFile(taskStatus.fileName);
                        }
                        setTimeout(function () {
                          _this10.isExporting = false;
                        }, 1500);
                      } else if (taskStatus.status === 'FAILED') {
                        clearInterval(pollInterval);
                        _this10.isExporting = false;
                        _this10.$message.error('导出失败: ' + (taskStatus.errorMessage || '未知错误'));
                      } else if (taskStatus.status === 'CANCELLED') {
                        clearInterval(pollInterval);
                        _this10.isExporting = false;
                        _this10.$message.warning('导出任务已中止');
                      } else {
                        // 未知状态或非处理中，停止轮询
                        clearInterval(pollInterval);
                        _this10.isExporting = false;
                      }
                      _context5.n = 3;
                      break;
                    case 2:
                      _context5.p = 2;
                      _t4 = _context5.v;
                      clearInterval(pollInterval);
                      _this10.isExporting = false;
                      _this10.$message.error('查询任务状态失败: ' + _t4.message);
                    case 3:
                      return _context5.a(2);
                  }
                }, _callee5, null, [[0, 2]]);
              })), 2000); // 每2秒查询一次状态
            case 1:
              return _context6.a(2);
          }
        }, _callee6);
      }));
      function pollTaskStatus(_x4) {
        return _pollTaskStatus.apply(this, arguments);
      }
      return pollTaskStatus;
    }(),
    // 轮询任务状态（支持排队模式）
    pollTaskStatusWithQueue: function () {
      var _pollTaskStatusWithQueue = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(taskId, taskType) {
        var _this11 = this;
        var pollInterval;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              pollInterval = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
                var detail, res, taskStatus, _t5, _t6;
                return _regenerator().w(function (_context7) {
                  while (1) switch (_context7.p = _context7.n) {
                    case 0:
                      _context7.p = 0;
                      _context7.p = 1;
                      _context7.n = 2;
                      return orderListApi.getDownloadQueueDetail(taskType);
                    case 2:
                      detail = _context7.v;
                      if (detail) {
                        _this11.queueDetail = detail;
                        if (detail.userMaxQueuePosition > 0) {
                          _this11.currentQueuePosition = detail.userMaxQueuePosition;
                        }
                      }
                      _context7.n = 4;
                      break;
                    case 3:
                      _context7.p = 3;
                      _t5 = _context7.v;
                    case 4:
                      _context7.n = 5;
                      return orderListApi.getDownloadTaskStatus(taskId);
                    case 5:
                      res = _context7.v;
                      taskStatus = res && res.data ? res.data : res;
                      if (taskStatus.status === 'WAITING') {
                        // 仍在排队中，更新排队位置
                        _this11.currentQueuePosition = taskStatus.queuePosition || 0;
                      } else if (taskStatus.status === 'PROCESSING') {
                        // 开始执行了
                        _this11.isInQueue = false;
                        _this11.exportProgress = 5;
                        clearInterval(pollInterval);
                        _this11.pollTaskStatus(taskId);
                      } else if (taskStatus.status === 'COMPLETED') {
                        _this11.exportProgress = 100;
                        clearInterval(pollInterval);
                        if (taskStatus.filePath) {
                          _this11.downloadFileByFilePath(taskStatus.filePath, taskStatus.fileName);
                        } else if (taskStatus.fileName) {
                          _this11.downloadFile(taskStatus.fileName);
                        }
                        setTimeout(function () {
                          _this11.isExporting = false;
                        }, 1500);
                      } else if (taskStatus.status === 'FAILED') {
                        clearInterval(pollInterval);
                        _this11.isExporting = false;
                        _this11.$message.error('导出失败: ' + (taskStatus.errorMessage || '未知错误'));
                      } else if (taskStatus.status === 'CANCELLED') {
                        clearInterval(pollInterval);
                        _this11.isExporting = false;
                        _this11.$message.warning('导出任务已中止');
                      } else {
                        clearInterval(pollInterval);
                        _this11.isExporting = false;
                      }
                      _context7.n = 7;
                      break;
                    case 6:
                      _context7.p = 6;
                      _t6 = _context7.v;
                      clearInterval(pollInterval);
                      _this11.isExporting = false;
                      _this11.$message.error('查询任务状态失败: ' + _t6.message);
                    case 7:
                      return _context7.a(2);
                  }
                }, _callee7, null, [[1, 3], [0, 6]]);
              })), 2000);
            case 1:
              return _context8.a(2);
          }
        }, _callee8);
      }));
      function pollTaskStatusWithQueue(_x5, _x6) {
        return _pollTaskStatusWithQueue.apply(this, arguments);
      }
      return pollTaskStatusWithQueue;
    }(),
    // 下载文件
    downloadFile: function () {
      var _downloadFile = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(fileName) {
        var response, url, a, errorMessage, _t7;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              _context9.p = 0;
              console.log('开始下载文件:', fileName);
              _context9.n = 1;
              return orderListApi.downloadFile(fileName);
            case 1:
              response = _context9.v;
              console.log('下载响应类型:', _typeof(response));
              console.log('下载响应是否为Blob:', response instanceof Blob);
              console.log('下载响应大小:', response instanceof Blob ? response.size : 'N/A');

              // 检查响应是否为 Blob 类型
              if (!(response instanceof Blob)) {
                _context9.n = 3;
                break;
              }
              if (!(response.size === 0)) {
                _context9.n = 2;
                break;
              }
              throw new Error('下载的文件为空');
            case 2:
              // 检查 Blob 类型
              if (response.type && !response.type.includes('sheet') && !response.type.includes('excel')) {
                console.warn('文件类型可能不正确:', response.type);
              }

              // 创建下载链接
              url = window.URL.createObjectURL(response);
              a = document.createElement('a');
              a.href = url;
              a.download = fileName;
              a.style.display = 'none';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
              this.$message.success('文件下载成功');
              _context9.n = 4;
              break;
            case 3:
              throw new Error('服务器返回的数据格式不正确');
            case 4:
              _context9.n = 6;
              break;
            case 5:
              _context9.p = 5;
              _t7 = _context9.v;
              console.error('下载文件错误:', _t7);

              // 改进错误信息处理
              errorMessage = '未知错误';
              if (_t7 instanceof Error) {
                errorMessage = _t7.message;
              } else if (typeof _t7 === 'string') {
                errorMessage = _t7;
              } else if (_t7 && _t7.toString) {
                errorMessage = _t7.toString();
              }
              this.$message.error('文件下载失败: ' + errorMessage);
            case 6:
              return _context9.a(2);
          }
        }, _callee9, this, [[0, 5]]);
      }));
      function downloadFile(_x7) {
        return _downloadFile.apply(this, arguments);
      }
      return downloadFile;
    }(),
    // 使用filePath下载文件
    downloadFileByFilePath: function () {
      var _downloadFileByFilePath = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(filePath, fileName) {
        var downloadUrl, httpsIndex, link;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              try {
                console.log('开始下载文件，filePath:', filePath);
                console.log('文件名:', fileName);

                // 从filePath中提取HTTPS URL部分
                downloadUrl = filePath; // 如果filePath包含https，则从https开始截取到最后
                httpsIndex = filePath.indexOf('https://');
                if (httpsIndex !== -1) {
                  downloadUrl = filePath.substring(httpsIndex);
                }
                console.log('原始filePath:', filePath);
                console.log('处理后的downloadUrl:', downloadUrl);

                // 创建隐藏的下载链接
                link = document.createElement('a');
                link.href = downloadUrl;
                link.download = fileName || 'download.xlsx';
                link.target = '_blank';
                link.style.display = 'none';

                // 添加到DOM并触发点击
                document.body.appendChild(link);
                link.click();

                // 清理DOM
                document.body.removeChild(link);
                this.$message.success('文件下载成功');
              } catch (error) {
                console.error('下载文件失败：', error);
                this.$message.error('下载文件失败：' + (error.message || '未知错误'));
              }
            case 1:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function downloadFileByFilePath(_x8, _x9) {
        return _downloadFileByFilePath.apply(this, arguments);
      }
      return downloadFileByFilePath;
    }(),
    // 财务导出（同步）
    exportFinanceList: function () {
      var _exportFinanceList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var loading, res, downloadUrl, a, _t8;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              loading = this.$loading({
                lock: true,
                text: '导出中....',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context1.p = 1;
              _context1.n = 2;
              return orderListApi.exportFinanceList(this.listPram);
            case 2:
              res = _context1.v;
              this.$message.success('导出成功');
              // 使用同步下载方式
              downloadUrl = "/api/admin/order/file/".concat(res.fileName);
              a = document.createElement('a');
              a.href = downloadUrl;
              a.download = res.fileName;
              a.style.display = 'none';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              _context1.n = 4;
              break;
            case 3:
              _context1.p = 3;
              _t8 = _context1.v;
              this.$message.error('导出失败: ' + _t8.message);
            case 4:
              _context1.p = 4;
              loading.close();
              return _context1.f(4);
            case 5:
              return _context1.a(2);
          }
        }, _callee1, this, [[1, 3, 4, 5]]);
      }));
      function exportFinanceList() {
        return _exportFinanceList.apply(this, arguments);
      }
      return exportFinanceList;
    }(),
    // 客户订单导出（异步，表结构同订单导出但去除成本价、供应商维护人；供应商名称仅线下购物显示）
    exportCustomerOrderList: function () {
      var _exportCustomerOrderList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var taskResponse, taskId, _t9;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.p = _context10.n) {
            case 0:
              this.isExporting = true;
              this.exportProgress = 0;
              this.isInQueue = false;
              this.currentQueuePosition = 0;
              _context10.p = 1;
              _context10.n = 2;
              return orderListApi.createAsyncCustomerExportTask(this.listPram);
            case 2:
              taskResponse = _context10.v;
              taskId = taskResponse.taskId;
              if (taskResponse.inQueue) {
                this.isInQueue = true;
                this.fetchQueueDetailAndUpdate('SUPPLIER_ORDER_EXPORT', taskId);
              } else {
                this.isInQueue = false;
                this.pollCustomerTaskStatus(taskId);
              }
              _context10.n = 4;
              break;
            case 3:
              _context10.p = 3;
              _t9 = _context10.v;
              this.isExporting = false;
              this.$message.error('创建导出任务失败: ' + _t9.message);
            case 4:
              return _context10.a(2);
          }
        }, _callee10, this, [[1, 3]]);
      }));
      function exportCustomerOrderList() {
        return _exportCustomerOrderList.apply(this, arguments);
      }
      return exportCustomerOrderList;
    }(),
    // 轮询客户订单导出任务状态
    pollCustomerTaskStatus: function () {
      var _pollCustomerTaskStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(taskId) {
        var _this12 = this;
        var pollInterval;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              pollInterval = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
                var res, taskStatus, _t0;
                return _regenerator().w(function (_context11) {
                  while (1) switch (_context11.p = _context11.n) {
                    case 0:
                      _context11.p = 0;
                      _context11.n = 1;
                      return orderListApi.getExportTaskStatus(taskId);
                    case 1:
                      res = _context11.v;
                      taskStatus = res && res.data ? res.data : res;
                      if (taskStatus.status === 'PROCESSING') {
                        _this12.exportProgress = Math.min(_this12.exportProgress + 5, 90);
                      } else if (taskStatus.status === 'COMPLETED') {
                        _this12.exportProgress = 100;
                        clearInterval(pollInterval);
                        if (taskStatus.filePath) {
                          _this12.downloadFileByFilePath(taskStatus.filePath, taskStatus.fileName);
                        } else if (taskStatus.fileName) {
                          _this12.downloadFile(taskStatus.fileName);
                        }
                        setTimeout(function () {
                          _this12.isExporting = false;
                        }, 1500);
                      } else if (taskStatus.status === 'FAILED') {
                        clearInterval(pollInterval);
                        _this12.isExporting = false;
                        _this12.$message.error('导出失败: ' + (taskStatus.errorMessage || '未知错误'));
                      } else if (taskStatus.status === 'CANCELLED') {
                        clearInterval(pollInterval);
                        _this12.isExporting = false;
                        _this12.$message.warning('导出任务已中止');
                      } else {
                        clearInterval(pollInterval);
                        _this12.isExporting = false;
                      }
                      _context11.n = 3;
                      break;
                    case 2:
                      _context11.p = 2;
                      _t0 = _context11.v;
                      clearInterval(pollInterval);
                      _this12.isExporting = false;
                      _this12.$message.error('查询任务状态失败: ' + _t0.message);
                    case 3:
                      return _context11.a(2);
                  }
                }, _callee11, null, [[0, 2]]);
              })), 2000);
            case 1:
              return _context12.a(2);
          }
        }, _callee12);
      }));
      function pollCustomerTaskStatus(_x0) {
        return _pollCustomerTaskStatus.apply(this, arguments);
      }
      return pollCustomerTaskStatus;
    }(),
    // 增强版订单导出（异步）
    exportEnhancedFinanceList: function () {
      var _exportEnhancedFinanceList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
        var taskResponse, taskId, _t1;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.p = _context13.n) {
            case 0:
              this.exportDialogTitle = '订单导出';
              this.exportConditionText = this.generateExportConditionText('订单导出');
              this.isExporting = true;
              this.exportProgress = 0;
              this.isInQueue = false;
              this.currentQueuePosition = 0;
              _context13.p = 1;
              _context13.n = 2;
              return orderListApi.createAsyncEnhancedExportTask(this.listPram);
            case 2:
              taskResponse = _context13.v;
              taskId = taskResponse.taskId;
              if (taskResponse.inQueue) {
                this.isInQueue = true;
                this.fetchQueueDetailAndUpdate('ENHANCED_ORDER_EXPORT', taskId);
              } else {
                this.isInQueue = false;
                this.pollEnhancedTaskStatus(taskId);
              }
              _context13.n = 4;
              break;
            case 3:
              _context13.p = 3;
              _t1 = _context13.v;
              this.isExporting = false;
              this.$message.error('创建导出任务失败: ' + _t1.message);
            case 4:
              return _context13.a(2);
          }
        }, _callee13, this, [[1, 3]]);
      }));
      function exportEnhancedFinanceList() {
        return _exportEnhancedFinanceList.apply(this, arguments);
      }
      return exportEnhancedFinanceList;
    }(),
    // 快速订单导出（异步，高性能）—— 根据系统配置决定是否弹出导出方式选择框
    exportFastOrderList: function exportFastOrderList() {
      var _this13 = this;
      this.exportMergeCell = true; // 重置为默认合并
      // 加载系统配置：是否支持不合并导出
      systemSettingApi.getOrderExportSupportNoMerge().then(function (res) {
        console.log('【订单导出】接口返回 res:', res, '| res.value:', res && res.value);
        var config = res; // 拦截器已经返回了 data 部分，res 本身就是配置对象
        _this13.supportNoMerge = config && (config.value === '1' || config.value === 'true');
        console.log('【订单导出】supportNoMerge:', _this13.supportNoMerge);
        if (_this13.supportNoMerge) {
          // 系统支持不合并，才弹出选择框让用户选择
          console.log('【订单导出】支持不合并，弹出选择框');
          _this13.exportMergeCellDialogVisible = true;
        } else {
          // 系统不支持不合并，默认使用合并导出，不弹框直接执行
          console.log('【订单导出】不支持不合并，直接执行合并导出');
          _this13.confirmExportFastOrder();
        }
      }).catch(function (err) {
        console.error('【订单导出】获取配置失败:', err);
        _this13.supportNoMerge = false;
        // 出错时也默认使用合并，不弹框
        _this13.confirmExportFastOrder();
      });
    },
    // 确认导出——根据用户选择的导出方式执行导出
    confirmExportFastOrder: function () {
      var _confirmExportFastOrder = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
        var _this$listPram2, status, requestParams, requestData, taskResponse, taskId, _t10;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.p = _context14.n) {
            case 0:
              this.exportMergeCellDialogVisible = false;
              this.exportDialogTitle = '订单导出';
              this.exportConditionText = this.generateExportConditionText('订单导出');
              this.isExporting = true;
              this.exportProgress = 0;
              this.isInQueue = false;
              this.currentQueuePosition = 0;
              _context14.p = 1;
              _this$listPram2 = this.listPram, status = _this$listPram2.status, requestParams = _objectWithoutProperties(_this$listPram2, _excluded3);
              requestData = _objectSpread(_objectSpread({}, requestParams), {}, {
                statusList: status,
                mergeCell: this.exportMergeCell
              });
              _context14.n = 2;
              return orderListApi.fastExportOrderList(requestData);
            case 2:
              taskResponse = _context14.v;
              if (!taskResponse.hasDuplicate) {
                _context14.n = 3;
                break;
              }
              this.isExporting = false;
              this.duplicateExportData = _objectSpread({}, taskResponse);
              this.duplicateExportDialogVisible = true;
              return _context14.a(2);
            case 3:
              taskId = taskResponse.taskId;
              if (taskResponse.inQueue) {
                this.isInQueue = true;
                this.fetchQueueDetailAndUpdate('FAST_ORDER_EXPORT', taskId);
              } else {
                this.isInQueue = false;
                this.pollFastExportTaskStatus(taskId);
              }
              _context14.n = 5;
              break;
            case 4:
              _context14.p = 4;
              _t10 = _context14.v;
              this.isExporting = false;
              this.$message.error('创建导出任务失败: ' + _t10.message);
            case 5:
              return _context14.a(2);
          }
        }, _callee14, this, [[1, 4]]);
      }));
      function confirmExportFastOrder() {
        return _confirmExportFastOrder.apply(this, arguments);
      }
      return confirmExportFastOrder;
    }(),
    // 轮询快速导出任务状态
    pollFastExportTaskStatus: function () {
      var _pollFastExportTaskStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(taskId) {
        var _this14 = this;
        var pollInterval;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.n) {
            case 0:
              pollInterval = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
                var res, taskStatus, _t11;
                return _regenerator().w(function (_context15) {
                  while (1) switch (_context15.p = _context15.n) {
                    case 0:
                      _context15.p = 0;
                      _context15.n = 1;
                      return orderListApi.getDownloadTaskStatus(taskId);
                    case 1:
                      res = _context15.v;
                      taskStatus = res && res.data ? res.data : res;
                      if (taskStatus.status === 'PROCESSING') {
                        _this14.exportProgress = Math.min(_this14.exportProgress + 5, 90);
                      } else if (taskStatus.status === 'COMPLETED') {
                        _this14.exportProgress = 100;
                        clearInterval(pollInterval);
                        if (taskStatus.filePath) {
                          _this14.downloadFileByFilePath(taskStatus.filePath, taskStatus.fileName);
                        } else if (taskStatus.fileName) {
                          _this14.downloadFile(taskStatus.fileName);
                        }
                        setTimeout(function () {
                          _this14.isExporting = false;
                        }, 1500);
                      } else if (taskStatus.status === 'FAILED') {
                        clearInterval(pollInterval);
                        _this14.isExporting = false;
                        _this14.$message.error('导出失败: ' + (taskStatus.errorMessage || '未知错误'));
                      } else if (taskStatus.status === 'CANCELLED') {
                        clearInterval(pollInterval);
                        _this14.isExporting = false;
                        _this14.$message.warning('导出任务已中止');
                      } else {
                        clearInterval(pollInterval);
                        _this14.isExporting = false;
                      }
                      _context15.n = 3;
                      break;
                    case 2:
                      _context15.p = 2;
                      _t11 = _context15.v;
                      clearInterval(pollInterval);
                      _this14.isExporting = false;
                      _this14.$message.error('查询任务状态失败: ' + _t11.message);
                    case 3:
                      return _context15.a(2);
                  }
                }, _callee15, null, [[0, 2]]);
              })), 2000);
            case 1:
              return _context16.a(2);
          }
        }, _callee16);
      }));
      function pollFastExportTaskStatus(_x1) {
        return _pollFastExportTaskStatus.apply(this, arguments);
      }
      return pollFastExportTaskStatus;
    }(),
    // 轮询增强版导出任务状态
    pollEnhancedTaskStatus: function () {
      var _pollEnhancedTaskStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(taskId) {
        var _this15 = this;
        var pollInterval;
        return _regenerator().w(function (_context18) {
          while (1) switch (_context18.n) {
            case 0:
              pollInterval = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17() {
                var res, taskStatus, _t12;
                return _regenerator().w(function (_context17) {
                  while (1) switch (_context17.p = _context17.n) {
                    case 0:
                      _context17.p = 0;
                      _context17.n = 1;
                      return orderListApi.getExportTaskStatus(taskId);
                    case 1:
                      res = _context17.v;
                      taskStatus = res && res.data ? res.data : res; // 更新进度：只有处理中状态才继续轮询
                      if (taskStatus.status === 'PROCESSING') {
                        _this15.exportProgress = Math.min(_this15.exportProgress + 5, 90);
                      } else if (taskStatus.status === 'COMPLETED') {
                        _this15.exportProgress = 100;
                        clearInterval(pollInterval);

                        // 直接使用filePath中的HTTPS地址下载文件
                        if (taskStatus.filePath) {
                          _this15.downloadFileByFilePath(taskStatus.filePath, taskStatus.fileName);
                        } else if (taskStatus.fileName) {
                          _this15.downloadFile(taskStatus.fileName);
                        }
                        setTimeout(function () {
                          _this15.isExporting = false;
                        }, 1500);
                      } else if (taskStatus.status === 'FAILED') {
                        clearInterval(pollInterval);
                        _this15.isExporting = false;
                        _this15.$message.error('导出失败: ' + (taskStatus.errorMessage || '未知错误'));
                      } else if (taskStatus.status === 'CANCELLED') {
                        clearInterval(pollInterval);
                        _this15.isExporting = false;
                        _this15.$message.warning('导出任务已中止');
                      } else {
                        clearInterval(pollInterval);
                        _this15.isExporting = false;
                      }
                      _context17.n = 3;
                      break;
                    case 2:
                      _context17.p = 2;
                      _t12 = _context17.v;
                      clearInterval(pollInterval);
                      _this15.isExporting = false;
                      _this15.$message.error('查询任务状态失败: ' + _t12.message);
                    case 3:
                      return _context17.a(2);
                  }
                }, _callee17, null, [[0, 2]]);
              })), 2000); // 每2秒查询一次状态
            case 1:
              return _context18.a(2);
          }
        }, _callee18);
      }));
      function pollEnhancedTaskStatus(_x10) {
        return _pollEnhancedTaskStatus.apply(this, arguments);
      }
      return pollEnhancedTaskStatus;
    }(),
    completeExport: function completeExport(fileName, intervalId) {
      var _this16 = this;
      clearInterval(intervalId); // 停止进度模拟
      this.exportProgress = 100; // 设置进度条为100%
      if (fileName) {
        // 创建一个隐藏的a标签来触发下载
        var a = document.createElement('a');
        a.href = fileName;
        a.download = fileName.split('/').pop();
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
      setTimeout(function () {
        _this16.isExporting = false; // 延迟关闭对话框，以便用户看到成功提示
      }, 1500);
    },
    exportOrderSendList: function exportOrderSendList() {
      var _this17 = this;
      this.exportDialogTitle = '订单发货导出';
      this.exportConditionText = this.generateExportConditionText('订单发货导出');
      this.isExporting = true; // 显示导出中提示
      this.exportProgress = 0; // 重置导出进度

      // 模拟导出进度，更慢的进度
      var intervalId = setInterval(function () {
        // 根据当前进度设置不同的增长速度
        var increment = 0;
        if (_this17.exportProgress < 30) {
          increment = 5; // 开始阶段快一点
        } else if (_this17.exportProgress < 60) {
          increment = 3; // 中间阶段慢一点
        } else {
          increment = 2; // 后期非常慢
        }
        _this17.exportProgress += increment;
        if (_this17.exportProgress >= 85) {
          clearInterval(intervalId); // 停止进度模拟
          // 保持在85%，等待实际完成后设为100%
          _this17.exportProgress = 85;
        }
      }, 800); // 每800毫秒增加一次进度

      // 发起导出请求
      orderListApi.exportOrderSendList(this.listPram).then(function (res) {
        clearInterval(intervalId); // 停止进度模拟
        _this17.exportProgress = 100; // 设置进度为100%

        setTimeout(function () {
          _this17.isExporting = false; // 延迟关闭对话框
          if (res.fileName) {
            window.open(res.fileName);
          }
        }, 1500);
      }).catch(function (error) {
        clearInterval(intervalId); // 停止进度模拟
        _this17.isExporting = false; // 隐藏导出中提示
        _this17.$message.error('导出请求失败: ' + error.message);
      });
    },
    exportOrderSendListSplit: function () {
      var _exportOrderSendListSplit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19() {
        var loading;
        return _regenerator().w(function (_context19) {
          while (1) switch (_context19.n) {
            case 0:
              loading = this.$loading({
                lock: true,
                text: '下载中....',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context19.n = 1;
              return (0, _downloadZip.downloadZipWithToken)('admin/order/export-split-zip', '订单发货——' + (0, _dateUtil.formatDateForFilename)());
            case 1:
              loading.close();
              this.$message.success('下载成功');
            case 2:
              return _context19.a(2);
          }
        }, _callee19, this);
      }));
      function exportOrderSendListSplit() {
        return _exportOrderSendListSplit.apply(this, arguments);
      }
      return exportOrderSendListSplit;
    }(),
    // 订单打标
    orderBindTag: function orderBindTag(orderNo) {
      this.$refs['BindTagRef'].openInit(orderNo);
    },
    sendOrder: function sendOrder(orderNo) {
      this.$refs['OrderSendRef'].openInit({
        orderNo: orderNo
      });
    },
    cancelUserOrder: function cancelUserOrder(orderNo) {
      this.$refs['CancelOrderRef'].openInit(orderNo);
    },
    sendMessage: function sendMessage(orderNo, skuName, tagRemark) {
      this.$refs['SendMsgRef'].openInit(orderNo, skuName, tagRemark);
    },
    // 修改收货地址
    updateReceive: function updateReceive(orderNo) {
      this.$refs['ChangeReceiveRef'].openInit(orderNo);
    },
    // 订单改价
    updatePrice: function updatePrice(orderNo) {
      this.$refs['ChangePriceRef'].openInit(orderNo);
    },
    handerAftersale: function handerAftersale() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var initInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // type: 0-创建售后
      this.$router.push({
        path: "/order/aftersale/aftersaleDetail/".concat(initInfo.aftersaleNo ? initInfo.aftersaleNo : 0, "/").concat(initInfo.orderNo ? initInfo.orderNo : 0, "/").concat(type)
      });
    },
    // 品牌查询
    searchBrand: function searchBrand() {
      var _this18 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var request = this.showMerchantStoreTypeFilter ? (0, _rensouApi.getBrand)({
        keyword: keyword
      }) : suplierCouponsApi.getAllBrand(keyword);
      return request.then(function (res) {
        _this18.brandOption = res && res.length && res.map(function (item) {
          var _ref7 = item || {},
            id = _ref7.id,
            brandName = _ref7.brandName;
          return {
            id: id,
            brandName: brandName,
            brandStr: "".concat(brandName, "--ID").concat(id)
          };
        }) || [];
      });
    },
    // 供应商查询
    searchSupplier: function searchSupplier() {
      var _this19 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.supplierOption = [];
      if (this.showMerchantStoreTypeFilter) {
        return (0, _rsApi.getSupplierOptions)().then(function (res) {
          var normalizedKeyword = String(keyword || '').trim().toLowerCase();
          _this19.supplierOption = (res || []).map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              supplierName: item.merchantName
            });
          }).filter(function (item) {
            return !normalizedKeyword || String(item.supplierName || '').toLowerCase().includes(normalizedKeyword);
          });
        });
      }
      return suplierCouponsApi.getAllSupplier(keyword).then(function (res) {
        _this19.supplierOption = res || [];
      });
    },
    // 搜索供应商
    handleSupplierSearch: function handleSupplierSearch(data) {
      var _this20 = this;
      this.throttle(function () {
        _this20.searchSupplier(data);
      }, 300)();
    },
    handleSupplierChange: function handleSupplierChange(supplierId) {
      this.listPram.storeId = '';
      this.storeOptions = [];
      if (supplierId) {
        this.getStoreOptions(supplierId);
      }
      this.handerSearch(0);
    },
    getStoreOptions: function () {
      var _getStoreOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(supplierId) {
        var orderType, supplier, merchantId, useMerchantStore, res, _t13, _t14;
        return _regenerator().w(function (_context20) {
          while (1) switch (_context20.p = _context20.n) {
            case 0:
              orderType = this.listPram.orderType;
              supplier = this.supplierOption.find(function (item) {
                return String(item.id) === String(supplierId);
              });
              merchantId = supplier ? supplier.merchantId : '';
              useMerchantStore = Boolean(merchantId);
              _context20.p = 1;
              if (!useMerchantStore) {
                _context20.n = 3;
                break;
              }
              _context20.n = 2;
              return (0, _rensouApi.getStore)({
                merchantId: merchantId
              });
            case 2:
              _t13 = _context20.v;
              _context20.n = 5;
              break;
            case 3:
              _context20.n = 4;
              return (0, _customerOrderApi.companyAutoListByTypestApi)({
                offlineSupplierId: supplierId
              });
            case 4:
              _t13 = _context20.v;
            case 5:
              res = _t13;
              if (!(String(this.listPram.supplierId) !== String(supplierId) || String(this.listPram.orderType) !== String(orderType))) {
                _context20.n = 6;
                break;
              }
              return _context20.a(2);
            case 6:
              this.storeOptions = (Array.isArray(res) ? res : []).map(function (item) {
                return {
                  storeId: item.key,
                  storeName: item.value
                };
              });
              _context20.n = 8;
              break;
            case 7:
              _context20.p = 7;
              _t14 = _context20.v;
              if (String(this.listPram.supplierId) === String(supplierId)) {
                this.storeOptions = [];
              }
            case 8:
              return _context20.a(2);
          }
        }, _callee20, this, [[1, 7]]);
      }));
      function getStoreOptions(_x11) {
        return _getStoreOptions.apply(this, arguments);
      }
      return getStoreOptions;
    }(),
    // 搜索品牌
    handleAgreementSearch: function handleAgreementSearch(data) {
      var _this21 = this;
      this.throttle(function () {
        _this21.searchBrand(data);
      }, 300)();
    },
    // 商户分类；
    getCategorySelect: function getCategorySelect() {
      var _this22 = this;
      var merchantType = this.showMerchantStoreTypeFilter;
      this.props = _objectSpread(_objectSpread({}, this.props), {}, {
        children: merchantType ? 'children' : 'child'
      });
      var request = merchantType ? (0, _merchantCategoryApi.getMerchantCategoryOptions)({
        type: 1
      }) : (0, _store.categoryApi)({
        status: -1,
        type: 1
      });
      return request.then(function (res) {
        _this22.merCateList = res;
      }).catch(function (res) {
        _this22.$message.error(res.message);
      });
    },
    // 获取订单标签
    getAllSelectTag: function getAllSelectTag() {
      var _this23 = this;
      this.selectTagList = [];
      orderTagApi.getSelectTag().then(function (res) {
        _this23.selectTagList = res || [];
      });
    },
    changeOrderState: function changeOrderState(orderNo) {
      var _this24 = this;
      this.$confirm('该笔订单会被直接操作为完结订单，确认无需发货吗？', '提示', {
        type: 'warning'
      }).then(function (result) {
        orderListApi.changeOrderState(orderNo).then(function (res) {
          _this24.$message.success('操作成功');
          _this24.handerSearch(0);
        });
      });
    },
    sendOrderKami: function sendOrderKami(row) {
      this.$refs['SendKamiRef'].openInit(row);
    },
    bindOrderKami: function bindOrderKami(orderNo) {
      var _this25 = this;
      orderListApi.updataKami({
        orderNo: orderNo
      }).then(function (res) {
        _this25.$message.success('操作成功');
        _this25.handerSearch(0);
      });
    },
    //远程搜索客户订单
    customrOrderRemoteMethod: function () {
      var _customrOrderRemoteMethod = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(query) {
        var res;
        return _regenerator().w(function (_context21) {
          while (1) switch (_context21.n) {
            case 0:
              _context21.n = 1;
              return orderListApi.getCustomrOrder({
                keyword: query
              });
            case 1:
              res = _context21.v;
              this.customerOrderList = res;
            case 2:
              return _context21.a(2);
          }
        }, _callee21, this);
      }));
      function customrOrderRemoteMethod(_x12) {
        return _customrOrderRemoteMethod.apply(this, arguments);
      }
      return customrOrderRemoteMethod;
    }(),
    // 归属公司
    getCustomers: function () {
      var _getCustomers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22() {
        var res;
        return _regenerator().w(function (_context22) {
          while (1) switch (_context22.n) {
            case 0:
              _context22.n = 1;
              return orderListApi.activeCustomersApi();
            case 1:
              res = _context22.v;
              this.customers = res;
            case 2:
              return _context22.a(2);
          }
        }, _callee22, this);
      }));
      function getCustomers() {
        return _getCustomers.apply(this, arguments);
      }
      return getCustomers;
    }(),
    getFuCardOptions: function () {
      var _getFuCardOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23() {
        var res, list;
        return _regenerator().w(function (_context23) {
          while (1) switch (_context23.n) {
            case 0:
              _context23.n = 1;
              return fudouActiveApi.orderCardListArticle({
                page: 1,
                limit: 1000
              });
            case 1:
              res = _context23.v;
              list = res && Array.isArray(res.list) ? res.list : [];
              this.fuCardOptions = list.map(function (_ref8) {
                var id = _ref8.id,
                  cardName = _ref8.cardName;
                return {
                  id: id,
                  cardName: cardName
                };
              });
            case 2:
              return _context23.a(2);
          }
        }, _callee23, this);
      }));
      function getFuCardOptions() {
        return _getFuCardOptions.apply(this, arguments);
      }
      return getFuCardOptions;
    }(),
    toggleForm: function toggleForm() {
      this.isFormVisible = !this.isFormVisible;
    },
    selectCompany: function selectCompany(company) {
      this.$set(this.listPram, 'company', company);
      this.handerSearch(0);
    },
    handelStatusPopup: function handelStatusPopup(row) {
      this.$refs['OrderStatusPopupRef'].handlePopupOpen(row);
    },
    goToDownloadTask: function goToDownloadTask() {
      this.downloadTaskDialogVisible = true;
    }
  }, "toggleForm", function toggleForm() {
    this.isFormVisible = !this.isFormVisible;
  })
};